













import Vue from 'vue';
import Icon from '../Icon/Icon.vue';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 24,
    },
    alt: {
      type: String,
      default: 'avatar',
    },
    title: {
      type: String,
      default: 'avatar',
    },
  },
});
